import { decodeHtmlEntities } from '@/utils/decodeHtmlEntities';
import type { RelatedPost } from '@/types/app';

interface PostCardProps {
  post: RelatedPost;
}

export function PostCard({ post }: PostCardProps) {
  const breadcrumbNames = new Set(
    (post.breadcrumbs ?? []).map((b) => b.name.toLowerCase())
  );
  const visibleCategories = (post.categories ?? []).filter(
    (cat) => !breadcrumbNames.has(cat.name.toLowerCase())
  );

  return (
    <article className="post-card">
      {post.featured_image && (
        <a href={post.permalink} className="post-card-image-wrapper">
          <img
            className="post-card-image"
            src={post.featured_image.url}
            alt={post.featured_image.alt}
            loading="lazy"
            width={640}
            height={400}
          />
        </a>
      )}
      {visibleCategories.length > 0 && (
        <div className="post-card-categories">
          {[...visibleCategories]
            .sort((a, b) => Number(b.is_primary) - Number(a.is_primary))
            .map((cat) => {
              const label = cat.name.charAt(0).toUpperCase() + cat.name.slice(1);
              return cat.link ? (
                <a key={cat.id} href={cat.link} className="post-card-category">
                  {label}
                </a>
              ) : (
                <span key={cat.id} className="post-card-category">
                  {label}
                </span>
              );
            })}
        </div>
      )}
      <a href={post.permalink} className="post-card-title-link">
        <h3 className="post-card-title">
          {decodeHtmlEntities(post.title)}
        </h3>
      </a>
      <div className="post-card-meta">
        <time className="post-card-date" dateTime={post.date}>
          {new Date(post.date).toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
        </time>
        {post.author && (
          <>
            <span className="post-card-separator">|</span>
            {post.author.link ? (
              <a
                href={post.author.link}
                className="post-card-author"
              >
                {post.author.name}
              </a>
            ) : (
              <span className="post-card-author">
                {post.author.name}
              </span>
            )}
          </>
        )}
      </div>
    </article>
  );
}
